import { Box } from "@mui/material";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import PATH from "../../helpers/PATH";
import AppFooter from "./Footer";
import AppHeader from "./Header";
import { AppLayoutWrapper } from "./styles";

const AppLayout = () => {
  const location = useLocation();

  // Не отображаем футер на странице логина
  const isAuthPage =
    location.pathname === PATH.APP_SIGNIN ||
    location.pathname.includes("/app/auth");

  // Проверяем, является ли текущая страница panoramic-results
  const isPanoramicResultsPage =
    location.pathname.includes("/panoramic-results");

  return (
    <AppLayoutWrapper>
      <Box bgcolor="gray.100" height="100%">
        {!isAuthPage && (
          <AppHeader isPanoramicResults={isPanoramicResultsPage} />
        )}
        <Outlet />
        {!isAuthPage && <AppFooter />}
      </Box>
    </AppLayoutWrapper>
  );
};

export default AppLayout;
